import usePreparingScanStore from "../../stores/usePreparingScanStore";
import useEditorStore from "../../stores/useEditorStore";
import { useRectificationStore, useElongationStore, useTrimlineStore, useThicknessStore, useFlareStore, useFlaresSmootheningStore } from "../../stores";
import { TOOLS_CONFIG } from "../../constants/tools";

import useSliceStore from "../../stores/tool/useSliceStore";

export const toolRegistry = {

};

toolRegistry[TOOLS_CONFIG.SCAN_PROCESS.PREPARING_SCAN.TRIM.id] = {
  exec: ({ mode }) => {
    switch(mode) {
      case 'trim': 
        return useSliceStore.getState().createTrimCommand();
      case 'invert':
        useSliceStore.getState().invertSelection();
        return null;
      case 'unselect': 
        const shadedMesh = useEditorStore.getState().sceneRefs.shadedMesh;
        if(shadedMesh)
          shadedMesh.visible = true;

        usePreparingScanStore.getState().clearSelection();      
        useSliceStore.getState().clearSlicePreview();   
        return null;
    }
  },
  undo: () => {
    useEditorStore.getState().undo(); // global undo command
  }
}

toolRegistry[TOOLS_CONFIG.SCAN_PROCESS.PREPARING_SCAN.FILL.id] = {
  exec: ({ mode }) => {
    // Correctly call the factory from the store. It returns the command object.
    return usePreparingScanStore.getState().createFillCommand();
  }
}

toolRegistry[TOOLS_CONFIG.MAIN_PROCESS.RECTIFICATION.main_rectification_measure_reduction.id] ={
  exec: ({mode}) => {
    if( mode === 'apply'){
      const command = useRectificationStore.getState().createRectificationCommand();
      useRectificationStore.getState().setCurrentRectificationCommand(command);
      return command;
    }
    return null; // No action for other modes
  }
} 

toolRegistry[TOOLS_CONFIG.MAIN_PROCESS.RECTIFICATION.main_rectification_scoop_recharge.id] = {
  exec: ({mode}) => {
    if( mode === 'apply'){
      const command = useRectificationStore.getState().createScoopRechargeCommand();
      useRectificationStore.getState().setCurrentScoopRechargeCommand(command);
      return command;
    }
    return null;
  }
}

toolRegistry[TOOLS_CONFIG.MAIN_PROCESS.RECTIFICATION.main_rectification_global_reduction.id] = {
  exec: ({mode}) => {
    if (mode === 'apply') {
      const command = useRectificationStore.getState().createGlobalReductionCommand();
      useRectificationStore.getState().setCurrentGlobalReductionCommand(command);
      return command;
    }
    return null;
  }
}

toolRegistry[TOOLS_CONFIG.MAIN_PROCESS.RECTIFICATION.main_rectification_smoothning.id] = {
  exec: ({ mode }) => {
    if (mode === 'apply') {
      const command = useRectificationStore.getState().createSmootheningCommand();
      useRectificationStore.getState().setCurrentSmootheningCommand(command);
      return command;
    }
    return null;
  }
}

toolRegistry[TOOLS_CONFIG.MAIN_PROCESS.ELONGATION.main_elongation_elongation.id] = {
  exec: ({ mode }) => {
    if( mode === 'apply'){
      const command = useElongationStore.getState().createElongationCommand();
      useElongationStore.getState().setCurrentElongationCommand(command);
      return command;
    }
    return null;
  }
}

toolRegistry[TOOLS_CONFIG.MAIN_PROCESS.TRIMLINE.main_trimline_trimline.id] = {
  exec: ({ mode }) => {
    if( mode === 'apply'){
      const command = useTrimlineStore.getState().createTrimlineCommand();
      useTrimlineStore.getState().setCurrentTrimlineCommand(command);
      return command;
    }
    return null;
  }
}

toolRegistry[TOOLS_CONFIG.MAIN_PROCESS.THICKNESS.main_thickness_thickness.id] = {
  exec: ({ mode }) => {
    if( mode === 'apply'){
      const command = useThicknessStore.getState().createThicknessCommand();
      useThicknessStore.getState().setCurrentThicknessCommand(command);
      return command;
    }
    return null;
  }
}

toolRegistry[TOOLS_CONFIG.MAIN_PROCESS.FLARES.main_flares_flare.id] = {
  exec: ({ mode }) => {
    if( mode === 'apply'){
      const command = useFlareStore.getState().createFlareCommand();
      useFlareStore.getState().setCurrentFlareCommand(command);
      return command;
    }
    return null;
  }
}

toolRegistry[TOOLS_CONFIG.MAIN_PROCESS.FLARES.main_flares_smoothning.id] = {
  exec: ({ mode }) => {
    if (mode === 'apply') {
      const command = useFlaresSmootheningStore.getState().createSmootheningCommand();
      useFlaresSmootheningStore.getState().setCurrentSmootheningCommand(command);
      return command;
    }
    return null;
  }
}